import { FC } from 'react';
import { Button } from 'antd';
import classNames from 'classnames';

interface BackgroundModalProps {
  isOpen: boolean;
  onClose: () => void;
  onBlur: () => void;
  backgrounds: { id: string; src: string }[];
  onSelect: (src: string) => void;
}

export const BackgroundModal: FC<BackgroundModalProps> = ({ isOpen, onClose, onBlur, backgrounds, onSelect }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-[14px] p-6 w-full max-w-[480px] max-h-[80vh] overflow-y-auto">
        <h3 className="text-xl font-bold text-center mb-6">Выберите фон</h3>

        <Button onClick={onBlur} className="w-full !py-3 mb-4" type="default">
          🌫️ Размытие фона
        </Button>

        <div className="grid grid-cols-3 sm:grid-cols-4 gap-3 mb-6">
          {backgrounds.map((bg) => (
            <div
              key={bg.id}
              className={classNames(
                'relative cursor-pointer rounded-md overflow-hidden border border-gray-200 hover:border-blue-400 transition-all',
              )}
              onClick={() => onSelect(bg.src)}
            >
              <img src={bg.src} alt={bg.id} className="w-full h-24 object-cover" />
            </div>
          ))}
        </div>

        <Button onClick={onClose} className="w-full !py-3 bg-gray-200 text-gray-700">
          Отмена
        </Button>
      </div>
    </div>
  );
};
